<template>
  <div>
    <el-dialog :lock-scroll="true" :close-on-click-modal="false" title="选择图片" :visible.sync="centerDialogVisible"
      width="30%" center :append-to-body='true'>
      <div style="display: flex;justify-content: center;">
        <el-image v-if="imageInfo.url" style="width: 300px; height:300px" :src="imageInfo.url"></el-image>
        <div v-else></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div style="color:#fff;display:flex;justify-content:space-around;overflow: hidden;">
          <el-button v-if="sougou" plain class="upload-button" @click="showDyhDialog">
            联 网 搜 索
          </el-button>
          <div v-if="fileInputShow" class="upload-logo" style="color:#fff;">
            <label for="home-list" style="position:absolute; width: 120px;height: 40px;">
              <input type="file" @change="uploadImg" style=" width: 120px;height: 40px;" ref="file" id="home-list"
                class="home-list" />
            </label>
            <el-button plain class="upload-button">
              本 地 图 片
            </el-button>

          </div>
          <div class="upload-logo">
            <el-button type="primary" class="upload-button" @click="hideDialog(true)">
              确 定
            </el-button>
          </div>
        </div>
      </span>
    </el-dialog>
    <dyhSougouImage ref="dyhSougouImageRef" @selectedImage="selectedImage"></dyhSougouImage>
  </div>

</template>
<script>
import dyhSougouImage from "./dyh-sougouImage.vue";
//eslint-disable-next-line
import { serviceUploadImg } from "@/api/service.js";
import { basicUploadImg } from '@/api/basic.js';
export default {
  components: { dyhSougouImage },
  props: ["sougou"],
  data() {
    return {
      fileInputShow: true,
      centerDialogVisible: false,
      imageInfo: {
        key: "",
        index: "",
        item_name: "",
        url: ""
      }
    }
  },
  methods: {
    /**
     * 点击确定返回选择信息
     * @param {boolean} v 是否点击确定
     */
    hideDialog(v) {
      if (v === true) {
        this.$emit("imageChoose", this.imageInfo);
      }
      this.centerDialogVisible = false;
      this.fileInputShow = false;
    },
    /**
     * 搜狗爬图返回
     * @param {object} e 选择的图片对象
     */
    selectedImage(e) {
      this.imageInfo = e;
    },
    /**
     * 显示选择窗口
     */
    showDyhImageCooseDialog(va) {
      this.centerDialogVisible = true;
      this.imageInfo = va;
      this.fileInputShow = true;
    },
    /**
     * 联网搜索商品
     * @param {string} key 需要修改的值
     * @param {number} index 索引
     * @param {string} item_name 需要搜索的关键字
     */
    showDyhDialog() {
      /* let key, item_name, index; */
      this.$refs.dyhSougouImageRef.showDailog(this.imageInfo.key, this.imageInfo.item_name, this.imageInfo.index);
    },
    /**
     * 本地文件上传图片
     * @param {Object} e file文件返回 系统返回文件上传事件
     * @param {number} index 索引
     * @param {string} key 需要修改的值
     */
    async uploadImg(e) {
      const that = this;
      var reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      /* eslint-disable */
      reader.onload = async function () {
        that.$set(that.imageInfo, "url", reader.result);
      }
      let file = e.target.files[0];
      let param = new FormData(); //创建form对象
      param.append('files', file);//通过append向form对象添加数据
      const res = await basicUploadImg(
        param
      );
      if (this.testR(res)) {
        that.$set(that.imageInfo, "media_no", res.data.resp_data[0].media_no);
      }
    }
  }
}
</script>
<style scoped>
#home-list {
  width: 120px !important;
  height: 40px !important;
  opacity: 0;
  cursor: pointer;
  z-index: 3;
}
</style>